export default {
  ALPHA: 'ALPHA',
  DESCQTY: 'DESCQTY',
  SPEC: 'SPEC',
  SPECNO0: 'SPECNO0',
  STANDARD: 'STANDARD',
};
